
import { defineComponent } from "vue";
import FeedItem from "@/components/home/FeedItem.vue";

export default defineComponent({
  components: { FeedItem },
});
